import React from 'react';
import histogram from '../../assets/images/icon_histogram.png';
import boxplot from '../../assets/images/icon_boxplot.png';
import bar from '../../assets/images/Icon_time-series.png';

const SegmentedControl = ({ selected, onChange = () => {}, vinShort }) => {
  const segments = [
    { label: 'Time Series', value: 'Bar', icon: bar },
    { label: 'Histogram', value: 'histogram', icon: histogram },
    { label: 'Boxplot', value: 'boxplot', icon: boxplot },
  ];

  const containerStyle = {
    display: 'flex',
    border: '1px solid gray',
    borderRadius: '16px', // Slightly smaller radius for a more compact look
    overflow: 'hidden',
    marginLeft: '10px',
  };

  const buttonStyle = (isSelected) => ({
    padding: '4px 12px', // Restored original padding
    cursor: 'pointer',
    backgroundColor: isSelected ? 'hsl(0, 0%, 90%)' : '#ffffff', // Changed to hsl(0, 0%, 90%) for selected state
    color: isSelected ? '#ffffff' : '#000000',
    border: 'none',
    outline: 'none',
    fontWeight: isSelected ? 'bold' : 'normal',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  const iconStyle = {
    height: '16px', // Reduced icon height
    width: '16px', // Adjusted width to maintain aspect ratio
  };

  return (
    <div style={containerStyle}>
      {segments.map((segment) => (
        <button
          key={segment.value}
          style={buttonStyle(selected === segment.value)}
          onClick={() => onChange(segment.value)}
          title={segment.label} // tooltip on hover
        >
          <img src={segment.icon} alt={segment.label} style={iconStyle} />
        </button>
      ))}
    </div>
  );
};

export default SegmentedControl;